// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2MDeb","list":"PatternAutocomplete_list__2B0Zk"};